<template>
  <div>
    <div class="form-header text-center pt-2 pb-3">
      <h3>{{ $route.meta.name }}</h3>
      <p>{{ $route.meta.description }}</p>
    </div>

    <div class="row justify-content-center pb-5">
      <button
        @click="addBusiness()"
        class="btn btn-brand-primary btn-lg"
      >Yes, Add Business</button>
    </div>
    <div class="mt-5">
      <form-nav-buttons
        :goBack="this.$route.meta.goBack"
        :next-route="nextRoute"
        :skippable="this.$route.meta.skippable"
      >
        <template
          slot="nextButton"
          slot-scope="next"
        >
          <button
            @click="continueToNext(next.next)"
            class="btn btn-brand-secondary btn-lg"
            type="button"
          >No, Continue</button>
        </template>
      </form-nav-buttons>
    </div>
  </div>
</template>

<script>
import { FormNavButtons } from 'components';

export default {
  name: 'basic-info',

  components: {
    FormNavButtons,
  },

  computed: {
    nextRoute() {
      if (this.$store.state.businessInfo.businesses.length < 2) {
        return '/businesses/0/billing-details';
      }
      return this.$route.meta.nextRoute;
    },
    goBack() {
      return this.$route.meta.goBack;
    },
  },

  methods: {
    continueToNext(callback) {
      callback();
    },
    addBusiness() {
      this.$store.dispatch('createEmptyBusiness').then(() => {
        this.$router.push(`/businesses/${this.$store.state.businessInfo.businesses.length - 1}/business-details`);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
